<template>
  <Modal
    ref="deleteSubAccountModalRef"
    @onNegativeActionClick="closeDeleteSubAccountModal"
    @onPositiveActionClick="deleteSubAccount"
    :isPositiveActionPending="isDeleteProductsLoading"
    :isPositiveActionButtonDisabled="isDeleteProductsLoading"
    negativeActionText="Vazgeç"
    positiveActionText="Hesabı Sil"
  >
    <template v-slot:body>
      <h3 class="modal-title">Hesabi silmek istediğinize emin misiniz?</h3>
      <p class="modal-text">
        Alt hesabın erişim yetkisi ve kullanıcı bilgileri silinecektir.
      </p>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { Modal } from "@n11/so-ui-components";
import { ToastMessageTypes } from "@/utils/enum/toastMessageTypes";

const props = defineProps({
  selectedUsername: {
    type: String,
    required: true,
    default: null,
  },
});

const emit = defineEmits(["successDeleteProduct"]);
const store = useStore();
const deleteSubAccountModalRef = ref();
const isDeleteProductsLoading = ref(false);

const openDeleteProductModal = () =>
  deleteSubAccountModalRef?.value?.openModal();
const closeDeleteSubAccountModal = () =>
  deleteSubAccountModalRef?.value?.hiddenModal();

const deleteSubAccount = async () => {
  try {
    const res = await store.dispatch(
      "accounts/deleteSubAccount",
      props.selectedUsername
    );
    emit("successDeleteProduct");
    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.SUCCESS,
      description: res.message,
    });
  } catch (error) {
    let errorMessage = "";
    if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "Bir hata oluştu";
    }
    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.ERROR,
      title: ToastMessageTypes.ERROR_TITLE,
      description: errorMessage,
    });
  } finally {
    isDeleteProductsLoading.value = false;
    closeDeleteSubAccountModal();
  }
};

defineExpose({
  openDeleteProductModal,
});
</script>

<style lang="scss" scoped>
.modal {
  &-title {
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
  }
  &-text {
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.05px;
  }
}
</style>
